import React, { useState } from 'react';

export const ConfiguratorModeContext = React.createContext();
/*
 * Opcje dla configuratorMode
 * 1. konfiguracja korpusów
 * 2. rodzaj korpusu
 * 3. Fronty
 * 4. Pattern frontów
 * 5. Uchwyty
 * 6  Akcesoria strefa
 * 7. Akcesoria
 * 8. Summary
 * 9. Opcje szafy
 * 10. przesuwanie
 * 11. dodawanie szafy
 * */

export const ConfiguratorModeProvider = ({ children }) => {
  const [currentConfiguratorMode, setCurrentConfiguratorMode] = useState(8);

  return (
    <ConfiguratorModeContext.Provider
      value={{ currentConfiguratorMode, setCurrentConfiguratorMode }}>
      {children}
    </ConfiguratorModeContext.Provider>
  );
};
